var cov_1rcczspfs8 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Modal/Panel.tsx",
      hash = "f2f8fc2b18c566bffb88ffbbe708e6a8e9897f13",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Modal/Panel.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 20
        },
        end: {
          line: 21,
          column: 25
        }
      },
      "2": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 31
        }
      },
      "3": {
        start: {
          line: 25,
          column: 53
        },
        end: {
          line: 25,
          column: 57
        }
      },
      "4": {
        start: {
          line: 27,
          column: 40
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "5": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "6": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 34,
          column: 9
        }
      },
      "7": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 24
        }
      },
      "8": {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 37,
          column: 58
        }
      },
      "9": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 16
        }
      },
      "10": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 50
        }
      },
      "11": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 75
        }
      },
      "12": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 71
        }
      },
      "13": {
        start: {
          line: 62,
          column: 26
        },
        end: {
          line: 62,
          column: 36
        }
      },
      "14": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 23
        }
      },
      "15": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 18
        }
      },
      "16": {
        start: {
          line: 66,
          column: 36
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "17": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 32
        }
      },
      "18": {
        start: {
          line: 67,
          column: 26
        },
        end: {
          line: 67,
          column: 32
        }
      },
      "19": {
        start: {
          line: 68,
          column: 15
        },
        end: {
          line: 68,
          column: 68
        }
      },
      "20": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "21": {
        start: {
          line: 69,
          column: 13
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "22": {
        start: {
          line: 70,
          column: 5
        },
        end: {
          line: 70,
          column: 32
        }
      },
      "23": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 30
        }
      },
      "24": {
        start: {
          line: 74,
          column: 24
        },
        end: {
          line: 74,
          column: 30
        }
      },
      "25": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 23
        }
      },
      "26": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 18
        }
      },
      "27": {
        start: {
          line: 80,
          column: 26
        },
        end: {
          line: 80,
          column: 36
        }
      },
      "28": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 70
        }
      },
      "29": {
        start: {
          line: 81,
          column: 59
        },
        end: {
          line: 81,
          column: 70
        }
      },
      "30": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 16
        }
      },
      "31": {
        start: {
          line: 86,
          column: 72
        },
        end: {
          line: 86,
          column: 82
        }
      },
      "32": {
        start: {
          line: 87,
          column: 14
        },
        end: {
          line: 87,
          column: 42
        }
      },
      "33": {
        start: {
          line: 88,
          column: 14
        },
        end: {
          line: 88,
          column: 43
        }
      },
      "34": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "35": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 21
        }
      },
      "36": {
        start: {
          line: 114,
          column: 36
        },
        end: {
          line: 114,
          column: 46
        }
      },
      "37": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 118,
          column: 6
        }
      },
      "38": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 50
        }
      },
      "39": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 66
        }
      },
      "40": {
        start: {
          line: 117,
          column: 21
        },
        end: {
          line: 117,
          column: 66
        }
      },
      "41": {
        start: {
          line: 122,
          column: 31
        },
        end: {
          line: 122,
          column: 41
        }
      },
      "42": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 33
        }
      },
      "43": {
        start: {
          line: 123,
          column: 27
        },
        end: {
          line: 123,
          column: 33
        }
      },
      "44": {
        start: {
          line: 124,
          column: 17
        },
        end: {
          line: 124,
          column: 27
        }
      },
      "45": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 32
        }
      },
      "46": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      "47": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 134,
          column: 7
        }
      },
      "48": {
        start: {
          line: 128,
          column: 30
        },
        end: {
          line: 128,
          column: 58
        }
      },
      "49": {
        start: {
          line: 129,
          column: 19
        },
        end: {
          line: 129,
          column: 41
        }
      },
      "50": {
        start: {
          line: 130,
          column: 19
        },
        end: {
          line: 130,
          column: 40
        }
      },
      "51": {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 131,
          column: 51
        }
      },
      "52": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 36
        }
      },
      "53": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 144,
          column: 25
        }
      },
      "54": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 23
        }
      },
      "55": {
        start: {
          line: 149,
          column: 39
        },
        end: {
          line: 149,
          column: 49
        }
      },
      "56": {
        start: {
          line: 150,
          column: 23
        },
        end: {
          line: 150,
          column: 24
        }
      },
      "57": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 30
        }
      },
      "58": {
        start: {
          line: 151,
          column: 24
        },
        end: {
          line: 151,
          column: 30
        }
      },
      "59": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 57
        }
      },
      "60": {
        start: {
          line: 152,
          column: 51
        },
        end: {
          line: 152,
          column: 57
        }
      },
      "61": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 153,
          column: 70
        }
      },
      "62": {
        start: {
          line: 153,
          column: 61
        },
        end: {
          line: 153,
          column: 70
        }
      },
      "63": {
        start: {
          line: 157,
          column: 21
        },
        end: {
          line: 157,
          column: 31
        }
      },
      "64": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 39
        }
      },
      "65": {
        start: {
          line: 158,
          column: 28
        },
        end: {
          line: 158,
          column: 39
        }
      },
      "66": {
        start: {
          line: 159,
          column: 21
        },
        end: {
          line: 159,
          column: 67
        }
      },
      "67": {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 160,
          column: 48
        }
      },
      "68": {
        start: {
          line: 164,
          column: 28
        },
        end: {
          line: 164,
          column: 38
        }
      },
      "69": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 165,
          column: 27
        }
      },
      "70": {
        start: {
          line: 165,
          column: 16
        },
        end: {
          line: 165,
          column: 27
        }
      },
      "71": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 173,
          column: 5
        }
      },
      "72": {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 170,
          column: 47
        }
      },
      "73": {
        start: {
          line: 170,
          column: 36
        },
        end: {
          line: 170,
          column: 47
        }
      },
      "74": {
        start: {
          line: 172,
          column: 6
        },
        end: {
          line: 172,
          column: 79
        }
      },
      "75": {
        start: {
          line: 176,
          column: 17
        },
        end: {
          line: 176,
          column: 34
        }
      },
      "76": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 183,
          column: 5
        }
      },
      "77": {
        start: {
          line: 187,
          column: 79
        },
        end: {
          line: 187,
          column: 89
        }
      },
      "78": {
        start: {
          line: 189,
          column: 31
        },
        end: {
          line: 189,
          column: 76
        }
      },
      "79": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 190,
          column: 41
        }
      },
      "80": {
        start: {
          line: 190,
          column: 18
        },
        end: {
          line: 190,
          column: 41
        }
      },
      "81": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 192,
          column: 58
        }
      },
      "82": {
        start: {
          line: 192,
          column: 19
        },
        end: {
          line: 192,
          column: 58
        }
      },
      "83": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 194,
          column: 90
        }
      },
      "84": {
        start: {
          line: 194,
          column: 36
        },
        end: {
          line: 194,
          column: 90
        }
      },
      "85": {
        start: {
          line: 196,
          column: 17
        },
        end: {
          line: 196,
          column: 34
        }
      },
      "86": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 204,
          column: 5
        }
      },
      "87": {
        start: {
          line: 222,
          column: 8
        },
        end: {
          line: 222,
          column: 18
        }
      },
      "88": {
        start: {
          line: 223,
          column: 22
        },
        end: {
          line: 223,
          column: 120
        }
      },
      "89": {
        start: {
          line: 224,
          column: 22
        },
        end: {
          line: 224,
          column: 107
        }
      },
      "90": {
        start: {
          line: 225,
          column: 22
        },
        end: {
          line: 225,
          column: 61
        }
      },
      "91": {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 261,
          column: 5
        }
      },
      "92": {
        start: {
          line: 265,
          column: 0
        },
        end: {
          line: 265,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "setTransformOrigin",
        decl: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 27
          }
        },
        loc: {
          start: {
            line: 20,
            column: 72
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 40
          },
          end: {
            line: 27,
            column: 41
          }
        },
        loc: {
          start: {
            line: 27,
            column: 52
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 13
          },
          end: {
            line: 32,
            column: 14
          }
        },
        loc: {
          start: {
            line: 32,
            column: 19
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 32
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        },
        loc: {
          start: {
            line: 54,
            column: 38
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 54
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 22
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 61
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 23
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 73
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 12
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 79
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 3
          }
        },
        loc: {
          start: {
            line: 85,
            column: 13
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 85
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 109,
            column: 14
          },
          end: {
            line: 109,
            column: 15
          }
        },
        loc: {
          start: {
            line: 109,
            column: 40
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 109
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 3
          }
        },
        loc: {
          start: {
            line: 113,
            column: 12
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 113
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 115,
            column: 15
          },
          end: {
            line: 115,
            column: 16
          }
        },
        loc: {
          start: {
            line: 115,
            column: 21
          },
          end: {
            line: 118,
            column: 5
          }
        },
        line: 115
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 121,
            column: 3
          }
        },
        loc: {
          start: {
            line: 121,
            column: 17
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 121
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 143,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        loc: {
          start: {
            line: 143,
            column: 69
          },
          end: {
            line: 145,
            column: 3
          }
        },
        line: 143
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 147,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        },
        loc: {
          start: {
            line: 147,
            column: 22
          },
          end: {
            line: 154,
            column: 3
          }
        },
        line: 147
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 156,
            column: 2
          },
          end: {
            line: 156,
            column: 3
          }
        },
        loc: {
          start: {
            line: 156,
            column: 15
          },
          end: {
            line: 161,
            column: 3
          }
        },
        line: 156
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 163,
            column: 2
          },
          end: {
            line: 163,
            column: 3
          }
        },
        loc: {
          start: {
            line: 163,
            column: 48
          },
          end: {
            line: 184,
            column: 3
          }
        },
        line: 163
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        },
        loc: {
          start: {
            line: 186,
            column: 18
          },
          end: {
            line: 205,
            column: 3
          }
        },
        line: 186
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 207,
            column: 2
          },
          end: {
            line: 207,
            column: 3
          }
        },
        loc: {
          start: {
            line: 207,
            column: 11
          },
          end: {
            line: 262,
            column: 3
          }
        },
        line: 207
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 32
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 32
          }
        }],
        line: 67
      },
      "1": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 69
      },
      "2": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 30
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 30
          }
        }],
        line: 74
      },
      "3": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 70
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 70
          }
        }],
        line: 81
      },
      "4": {
        loc: {
          start: {
            line: 87,
            column: 14
          },
          end: {
            line: 87,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 27
          },
          end: {
            line: 87,
            column: 34
          }
        }, {
          start: {
            line: 87,
            column: 37
          },
          end: {
            line: 87,
            column: 42
          }
        }],
        line: 87
      },
      "5": {
        loc: {
          start: {
            line: 88,
            column: 14
          },
          end: {
            line: 88,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 27
          },
          end: {
            line: 88,
            column: 34
          }
        }, {
          start: {
            line: 88,
            column: 37
          },
          end: {
            line: 88,
            column: 43
          }
        }],
        line: 88
      },
      "6": {
        loc: {
          start: {
            line: 93,
            column: 6
          },
          end: {
            line: 104,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 10
          },
          end: {
            line: 97,
            column: 11
          }
        }, {
          start: {
            line: 98,
            column: 10
          },
          end: {
            line: 104,
            column: 11
          }
        }],
        line: 93
      },
      "7": {
        loc: {
          start: {
            line: 95,
            column: 19
          },
          end: {
            line: 95,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 95,
            column: 68
          },
          end: {
            line: 95,
            column: 69
          }
        }, {
          start: {
            line: 95,
            column: 72
          },
          end: {
            line: 95,
            column: 81
          }
        }],
        line: 95
      },
      "8": {
        loc: {
          start: {
            line: 95,
            column: 19
          },
          end: {
            line: 95,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 19
          },
          end: {
            line: 95,
            column: 25
          }
        }, {
          start: {
            line: 95,
            column: 29
          },
          end: {
            line: 95,
            column: 65
          }
        }],
        line: 95
      },
      "9": {
        loc: {
          start: {
            line: 96,
            column: 20
          },
          end: {
            line: 96,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 96,
            column: 69
          },
          end: {
            line: 96,
            column: 70
          }
        }, {
          start: {
            line: 96,
            column: 73
          },
          end: {
            line: 96,
            column: 82
          }
        }],
        line: 96
      },
      "10": {
        loc: {
          start: {
            line: 96,
            column: 20
          },
          end: {
            line: 96,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 20
          },
          end: {
            line: 96,
            column: 26
          }
        }, {
          start: {
            line: 96,
            column: 30
          },
          end: {
            line: 96,
            column: 66
          }
        }],
        line: 96
      },
      "11": {
        loc: {
          start: {
            line: 102,
            column: 17
          },
          end: {
            line: 102,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 102,
            column: 30
          },
          end: {
            line: 102,
            column: 31
          }
        }, {
          start: {
            line: 102,
            column: 34
          },
          end: {
            line: 102,
            column: 37
          }
        }],
        line: 102
      },
      "12": {
        loc: {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 105,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 105,
            column: 11
          }
        }, {
          start: {
            line: 105,
            column: 15
          },
          end: {
            line: 105,
            column: 17
          }
        }],
        line: 105
      },
      "13": {
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 66
          }
        }, {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 66
          }
        }],
        line: 117
      },
      "14": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 33
          }
        }, {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 33
          }
        }],
        line: 123
      },
      "15": {
        loc: {
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 123,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 123,
            column: 16
          }
        }, {
          start: {
            line: 123,
            column: 20
          },
          end: {
            line: 123,
            column: 25
          }
        }],
        line: 123
      },
      "16": {
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 126
      },
      "17": {
        loc: {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        }, {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        }],
        line: 127
      },
      "18": {
        loc: {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 151,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 151,
            column: 30
          }
        }, {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 151,
            column: 30
          }
        }],
        line: 151
      },
      "19": {
        loc: {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 57
          }
        }, {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 57
          }
        }],
        line: 152
      },
      "20": {
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 153,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 153,
            column: 70
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 153,
            column: 70
          }
        }],
        line: 153
      },
      "21": {
        loc: {
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 153,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 153,
            column: 48
          }
        }, {
          start: {
            line: 153,
            column: 52
          },
          end: {
            line: 153,
            column: 59
          }
        }],
        line: 153
      },
      "22": {
        loc: {
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 158,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 158,
            column: 39
          }
        }, {
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 158,
            column: 39
          }
        }],
        line: 158
      },
      "23": {
        loc: {
          start: {
            line: 163,
            column: 14
          },
          end: {
            line: 163,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 163,
            column: 41
          },
          end: {
            line: 163,
            column: 46
          }
        }],
        line: 163
      },
      "24": {
        loc: {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 27
          }
        }, {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 27
          }
        }],
        line: 165
      },
      "25": {
        loc: {
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        }, {
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        }],
        line: 168
      },
      "26": {
        loc: {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 170,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 170,
            column: 47
          }
        }, {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 170,
            column: 47
          }
        }],
        line: 170
      },
      "27": {
        loc: {
          start: {
            line: 179,
            column: 50
          },
          end: {
            line: 179,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 50
          },
          end: {
            line: 179,
            column: 54
          }
        }, {
          start: {
            line: 179,
            column: 58
          },
          end: {
            line: 179,
            column: 69
          }
        }],
        line: 179
      },
      "28": {
        loc: {
          start: {
            line: 180,
            column: 9
          },
          end: {
            line: 180,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 9
          },
          end: {
            line: 180,
            column: 13
          }
        }, {
          start: {
            line: 180,
            column: 17
          },
          end: {
            line: 180,
            column: 65
          }
        }],
        line: 180
      },
      "29": {
        loc: {
          start: {
            line: 187,
            column: 63
          },
          end: {
            line: 187,
            column: 74
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 187,
            column: 70
          },
          end: {
            line: 187,
            column: 74
          }
        }],
        line: 187
      },
      "30": {
        loc: {
          start: {
            line: 189,
            column: 42
          },
          end: {
            line: 189,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 189,
            column: 63
          },
          end: {
            line: 189,
            column: 64
          }
        }, {
          start: {
            line: 189,
            column: 67
          },
          end: {
            line: 189,
            column: 74
          }
        }],
        line: 189
      },
      "31": {
        loc: {
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 190,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 190,
            column: 41
          }
        }, {
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 190,
            column: 41
          }
        }],
        line: 190
      },
      "32": {
        loc: {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 58
          }
        }, {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 58
          }
        }],
        line: 192
      },
      "33": {
        loc: {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 90
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 90
          }
        }, {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 90
          }
        }],
        line: 194
      },
      "34": {
        loc: {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 194,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 194,
            column: 13
          }
        }, {
          start: {
            line: 194,
            column: 17
          },
          end: {
            line: 194,
            column: 34
          }
        }],
        line: 194
      },
      "35": {
        loc: {
          start: {
            line: 200,
            column: 9
          },
          end: {
            line: 200,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 200,
            column: 9
          },
          end: {
            line: 200,
            column: 13
          }
        }, {
          start: {
            line: 200,
            column: 17
          },
          end: {
            line: 200,
            column: 65
          }
        }],
        line: 200
      },
      "36": {
        loc: {
          start: {
            line: 223,
            column: 69
          },
          end: {
            line: 223,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 223,
            column: 69
          },
          end: {
            line: 223,
            column: 73
          }
        }, {
          start: {
            line: 223,
            column: 77
          },
          end: {
            line: 223,
            column: 86
          }
        }, {
          start: {
            line: 223,
            column: 90
          },
          end: {
            line: 223,
            column: 96
          }
        }],
        line: 223
      },
      "37": {
        loc: {
          start: {
            line: 224,
            column: 22
          },
          end: {
            line: 224,
            column: 107
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 224,
            column: 55
          },
          end: {
            line: 224,
            column: 65
          }
        }, {
          start: {
            line: 224,
            column: 68
          },
          end: {
            line: 224,
            column: 107
          }
        }],
        line: 224
      },
      "38": {
        loc: {
          start: {
            line: 224,
            column: 68
          },
          end: {
            line: 224,
            column: 107
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 224,
            column: 68
          },
          end: {
            line: 224,
            column: 81
          }
        }, {
          start: {
            line: 224,
            column: 85
          },
          end: {
            line: 224,
            column: 107
          }
        }],
        line: 224
      },
      "39": {
        loc: {
          start: {
            line: 225,
            column: 39
          },
          end: {
            line: 225,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 225,
            column: 52
          },
          end: {
            line: 225,
            column: 53
          }
        }, {
          start: {
            line: 225,
            column: 56
          },
          end: {
            line: 225,
            column: 59
          }
        }],
        line: 225
      },
      "40": {
        loc: {
          start: {
            line: 245,
            column: 15
          },
          end: {
            line: 249,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 245,
            column: 15
          },
          end: {
            line: 245,
            column: 24
          }
        }, {
          start: {
            line: 246,
            column: 16
          },
          end: {
            line: 248,
            column: 20
          }
        }],
        line: 245
      },
      "41": {
        loc: {
          start: {
            line: 252,
            column: 15
          },
          end: {
            line: 256,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 252,
            column: 15
          },
          end: {
            line: 252,
            column: 21
          }
        }, {
          start: {
            line: 253,
            column: 16
          },
          end: {
            line: 255,
            column: 30
          }
        }],
        line: 252
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Modal/Panel.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Icons from '../icons';
import Card from '../Card';
import { defaultProps } from '../utils/defaultProps';
import { modalClass } from './styles';
import { Provider } from '../Scroll/context';
import { Provider as ZProvider } from './context';
var DefaultValue = (cov_1rcczspfs8.s[0]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  top: '10vh',
  maskCloseAble: true,
  width: 500,
  events: {},
  drawer: false
}));

function setTransformOrigin(node, value) {
  cov_1rcczspfs8.f[0]++;

  var _ref = (cov_1rcczspfs8.s[1]++, node),
      style = _ref.style;

  cov_1rcczspfs8.s[2]++;
  style.transformOrigin = value;
}

var mousePosition = (cov_1rcczspfs8.s[3]++, null);
cov_1rcczspfs8.s[4]++;

var getClickPosition = function getClickPosition(e) {
  cov_1rcczspfs8.f[1]++;
  cov_1rcczspfs8.s[5]++;
  mousePosition = {
    x: e.clientX,
    y: e.clientY
  };
  cov_1rcczspfs8.s[6]++;
  setTimeout(function () {
    cov_1rcczspfs8.f[2]++;
    cov_1rcczspfs8.s[7]++;
    mousePosition = null;
  }, 100);
};

cov_1rcczspfs8.s[8]++;
document.addEventListener('click', getClickPosition, true);

var Panel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Panel, _PureComponent);

  var _super = _createSuper2(Panel);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    cov_1rcczspfs8.f[3]++;
    cov_1rcczspfs8.s[9]++;
    _this = _super.call(this, props);
    _this.panel = void 0;
    _this.handleMaskDown = void 0;
    _this.handleMaskUp = void 0;
    _this.maskDownTarget = void 0;
    _this.maskUpTarget = void 0;

    _this.savePanel = function (node) {
      cov_1rcczspfs8.f[8]++;
      cov_1rcczspfs8.s[35]++;
      _this.panel = node;
    };

    cov_1rcczspfs8.s[10]++;
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    cov_1rcczspfs8.s[11]++;
    _this.handleMaskDown = _this.handleMaskClick.bind(_assertThisInitialized(_this), 'maskDownTarget');
    cov_1rcczspfs8.s[12]++;
    _this.handleMaskUp = _this.handleMaskClick.bind(_assertThisInitialized(_this), 'maskUpTarget');
    return _this;
  }

  _createClass(Panel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1rcczspfs8.f[4]++;

      var _ref2 = (cov_1rcczspfs8.s[13]++, this.props),
          container = _ref2.container;

      cov_1rcczspfs8.s[14]++;
      this.updateOrigin();
      cov_1rcczspfs8.s[15]++;
      this.animate();

      var _ref3 = (cov_1rcczspfs8.s[16]++, this.props),
          autoFocusButton = _ref3.autoFocusButton,
          id = _ref3.id;

      cov_1rcczspfs8.s[17]++;

      if (!autoFocusButton) {
        cov_1rcczspfs8.b[0][0]++;
        cov_1rcczspfs8.s[18]++;
        return;
      } else {
        cov_1rcczspfs8.b[0][1]++;
      }

      var el = (cov_1rcczspfs8.s[19]++, container.querySelector("#".concat(id, "-").concat(autoFocusButton)));
      cov_1rcczspfs8.s[20]++;

      if (!el) {
        cov_1rcczspfs8.b[1][0]++;
        cov_1rcczspfs8.s[21]++;
        return;
      } else {
        cov_1rcczspfs8.b[1][1]++;
      }

      cov_1rcczspfs8.s[22]++;
      el.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_1rcczspfs8.f[5]++;
      cov_1rcczspfs8.s[23]++;

      if (this.getShow()) {
        cov_1rcczspfs8.b[2][0]++;
        cov_1rcczspfs8.s[24]++;
        return;
      } else {
        cov_1rcczspfs8.b[2][1]++;
      }

      cov_1rcczspfs8.s[25]++;
      this.updateOrigin();
      cov_1rcczspfs8.s[26]++;
      this.animate();
    }
  }, {
    key: "getShow",
    value: function getShow() {
      cov_1rcczspfs8.f[6]++;

      var _ref4 = (cov_1rcczspfs8.s[27]++, this.props),
          container = _ref4.container;

      cov_1rcczspfs8.s[28]++;

      if (container.classList.contains(modalClass('show'))) {
        cov_1rcczspfs8.b[3][0]++;
        cov_1rcczspfs8.s[29]++;
        return true;
      } else {
        cov_1rcczspfs8.b[3][1]++;
      }

      cov_1rcczspfs8.s[30]++;
      return false;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      cov_1rcczspfs8.f[7]++;

      var _ref5 = (cov_1rcczspfs8.s[31]++, this.props),
          width = _ref5.width,
          height = _ref5.height,
          top = _ref5.top,
          position = _ref5.position,
          style = _ref5.style,
          fullScreen = _ref5.fullScreen,
          drawer = _ref5.drawer;

      var w = (cov_1rcczspfs8.s[32]++, fullScreen ? (cov_1rcczspfs8.b[4][0]++, '100vw') : (cov_1rcczspfs8.b[4][1]++, width));
      var h = (cov_1rcczspfs8.s[33]++, fullScreen ? (cov_1rcczspfs8.b[5][0]++, '100vh') : (cov_1rcczspfs8.b[5][1]++, height));
      cov_1rcczspfs8.s[34]++;
      return Object.assign({
        position: 'absolute'
      }, position ? (cov_1rcczspfs8.b[6][0]++, {
        width: (cov_1rcczspfs8.b[8][0]++, drawer) && (cov_1rcczspfs8.b[8][1]++, ['left', 'right'].includes(position)) ? (cov_1rcczspfs8.b[7][0]++, w) : (cov_1rcczspfs8.b[7][1]++, undefined),
        height: (cov_1rcczspfs8.b[10][0]++, drawer) && (cov_1rcczspfs8.b[10][1]++, ['top', 'bottom'].includes(position)) ? (cov_1rcczspfs8.b[9][0]++, h) : (cov_1rcczspfs8.b[9][1]++, undefined)
      }) : (cov_1rcczspfs8.b[6][1]++, {
        display: 'inline-flex',
        width: w,
        height: h,
        top: fullScreen ? (cov_1rcczspfs8.b[11][0]++, 0) : (cov_1rcczspfs8.b[11][1]++, top),
        position: 'relative'
      }), (cov_1rcczspfs8.b[12][0]++, style) || (cov_1rcczspfs8.b[12][1]++, {}));
    }
  }, {
    key: "animate",
    value: function animate() {
      cov_1rcczspfs8.f[9]++;

      var _ref6 = (cov_1rcczspfs8.s[36]++, this.props),
          container = _ref6.container,
          position = _ref6.position;

      cov_1rcczspfs8.s[37]++;
      setTimeout(function () {
        cov_1rcczspfs8.f[10]++;
        cov_1rcczspfs8.s[38]++;
        container.classList.add(modalClass('show'));
        cov_1rcczspfs8.s[39]++;

        if (!position) {
          cov_1rcczspfs8.b[13][0]++;
          cov_1rcczspfs8.s[40]++;
          container.classList.add(modalClass('start'));
        } else {
          cov_1rcczspfs8.b[13][1]++;
        }
      });
    }
  }, {
    key: "updateOrigin",
    value: function updateOrigin() {
      cov_1rcczspfs8.f[11]++;

      var _ref7 = (cov_1rcczspfs8.s[41]++, this.props),
          position = _ref7.position,
          zoom = _ref7.zoom;

      cov_1rcczspfs8.s[42]++;

      if ((cov_1rcczspfs8.b[15][0]++, position) || (cov_1rcczspfs8.b[15][1]++, !zoom)) {
        cov_1rcczspfs8.b[14][0]++;
        cov_1rcczspfs8.s[43]++;
        return;
      } else {
        cov_1rcczspfs8.b[14][1]++;
      }

      var node = (cov_1rcczspfs8.s[44]++, this.panel);
      cov_1rcczspfs8.s[45]++;
      setTransformOrigin(node, '');
      cov_1rcczspfs8.s[46]++;

      if (node) {
        cov_1rcczspfs8.b[16][0]++;
        cov_1rcczspfs8.s[47]++;

        if (mousePosition) {
          cov_1rcczspfs8.b[17][0]++;

          var _ref8 = (cov_1rcczspfs8.s[48]++, node.getBoundingClientRect()),
              left = _ref8.left,
              top = _ref8.top;

          var ol = (cov_1rcczspfs8.s[49]++, mousePosition.x - left);
          var ot = (cov_1rcczspfs8.s[50]++, mousePosition.y - top);
          cov_1rcczspfs8.s[51]++;
          setTransformOrigin(node, "".concat(ol, "px ").concat(ot, "px"));
        } else {
          cov_1rcczspfs8.b[17][1]++;
          cov_1rcczspfs8.s[52]++;
          setTransformOrigin(node, '');
        }
      } else {
        cov_1rcczspfs8.b[16][1]++;
      }
    } // eslint-disable-next-line
    // lockWheel(event) {
    //   event.preventDefault()
    // }

  }, {
    key: "handleMaskClick",
    value: function handleMaskClick(type, e) {
      cov_1rcczspfs8.f[12]++;
      cov_1rcczspfs8.s[53]++;
      this[type] = e.target;
    }
  }, {
    key: "handleClose",
    value: function handleClose(e) {
      cov_1rcczspfs8.f[13]++;
      cov_1rcczspfs8.s[54]++;
      e.stopPropagation();

      var _ref9 = (cov_1rcczspfs8.s[55]++, this.props),
          maskCloseAble = _ref9.maskCloseAble,
          onClose = _ref9.onClose;

      var _ref10 = (cov_1rcczspfs8.s[56]++, e),
          target = _ref10.target;

      cov_1rcczspfs8.s[57]++;

      if (!maskCloseAble) {
        cov_1rcczspfs8.b[18][0]++;
        cov_1rcczspfs8.s[58]++;
        return;
      } else {
        cov_1rcczspfs8.b[18][1]++;
      }

      cov_1rcczspfs8.s[59]++;

      if (this.maskDownTarget !== this.maskUpTarget) {
        cov_1rcczspfs8.b[19][0]++;
        cov_1rcczspfs8.s[60]++;
        return;
      } else {
        cov_1rcczspfs8.b[19][1]++;
      }

      cov_1rcczspfs8.s[61]++;

      if ((cov_1rcczspfs8.b[21][0]++, target.matches(".".concat(modalClass('mask')))) && (cov_1rcczspfs8.b[21][1]++, onClose)) {
        cov_1rcczspfs8.b[20][0]++;
        cov_1rcczspfs8.s[62]++;
        onClose();
      } else {
        cov_1rcczspfs8.b[20][1]++;
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      cov_1rcczspfs8.f[14]++;

      var _ref11 = (cov_1rcczspfs8.s[63]++, this.props),
          type = _ref11.type;

      cov_1rcczspfs8.s[64]++;

      if (type === 'default') {
        cov_1rcczspfs8.b[22][0]++;
        cov_1rcczspfs8.s[65]++;
        return null;
      } else {
        cov_1rcczspfs8.b[22][1]++;
      }

      var iconType = (cov_1rcczspfs8.s[66]++, type.charAt(0).toUpperCase() + type.slice(1));
      cov_1rcczspfs8.s[67]++;
      return Icons[iconType];
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var justRenderClassComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1rcczspfs8.b[23][0]++, false);
      cov_1rcczspfs8.f[15]++;

      var _ref12 = (cov_1rcczspfs8.s[68]++, this.props),
          from = _ref12.from,
          title = _ref12.title;

      cov_1rcczspfs8.s[69]++;

      if (!title) {
        cov_1rcczspfs8.b[24][0]++;
        cov_1rcczspfs8.s[70]++;
        return null;
      } else {
        cov_1rcczspfs8.b[24][1]++;
      } // method component


      cov_1rcczspfs8.s[71]++;

      if (from === 'method') {
        cov_1rcczspfs8.b[25][0]++;
        cov_1rcczspfs8.s[72]++;

        // if just render class Component, return null
        if (justRenderClassComponent) {
          cov_1rcczspfs8.b[26][0]++;
          cov_1rcczspfs8.s[73]++;
          return null;
        } else {
          cov_1rcczspfs8.b[26][1]++;
        } // for  method function


        cov_1rcczspfs8.s[74]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: modalClass('title', 'method-title'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 172,
              columnNumber: 14
            }
          }, title)
        );
      } else {
        cov_1rcczspfs8.b[25][1]++;
      } // base Component


      var icon = (cov_1rcczspfs8.s[75]++, this.renderIcon());
      cov_1rcczspfs8.s[76]++;
      return (
        /*#__PURE__*/
        React.createElement(Card.Header, {
          className: modalClass('title', (cov_1rcczspfs8.b[27][0]++, icon) && (cov_1rcczspfs8.b[27][1]++, 'with-icon')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 179,
            columnNumber: 7
          }
        }, (cov_1rcczspfs8.b[28][0]++, icon) && (cov_1rcczspfs8.b[28][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: modalClass('icon'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 180,
            columnNumber: 18
          }
        }, icon)), title)
      );
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      cov_1rcczspfs8.f[16]++;

      var _ref13 = (cov_1rcczspfs8.s[77]++, this.props),
          children = _ref13.children,
          noPadding = _ref13.noPadding,
          padding = _ref13.padding,
          position = _ref13.position,
          bodyStyle = _ref13.bodyStyle,
          _ref13$from = _ref13.from,
          from = _ref13$from === void 0 ? (cov_1rcczspfs8.b[29][0]++, null) : _ref13$from;

      var style = (cov_1rcczspfs8.s[78]++, {
        padding: noPadding === true ? (cov_1rcczspfs8.b[30][0]++, 0) : (cov_1rcczspfs8.b[30][1]++, padding)
      });
      cov_1rcczspfs8.s[79]++;

      if (position) {
        cov_1rcczspfs8.b[31][0]++;
        cov_1rcczspfs8.s[80]++;
        style.overflow = 'auto';
      } else {
        cov_1rcczspfs8.b[31][1]++;
      }

      cov_1rcczspfs8.s[81]++;

      if (bodyStyle) {
        cov_1rcczspfs8.b[32][0]++;
        cov_1rcczspfs8.s[82]++;
        style = Object.assign(style, bodyStyle);
      } else {
        cov_1rcczspfs8.b[32][1]++;
      }

      cov_1rcczspfs8.s[83]++;

      if ((cov_1rcczspfs8.b[34][0]++, !from) || (cov_1rcczspfs8.b[34][1]++, from !== 'method')) {
        cov_1rcczspfs8.b[33][0]++;
        cov_1rcczspfs8.s[84]++;
        return (
          /*#__PURE__*/
          React.createElement(Card.Body, {
            style: style,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 194,
              columnNumber: 44
            }
          }, children)
        );
      } else {
        cov_1rcczspfs8.b[33][1]++;
      }

      var icon = (cov_1rcczspfs8.s[85]++, this.renderIcon());
      cov_1rcczspfs8.s[86]++;
      return (
        /*#__PURE__*/
        React.createElement(Card.Body, {
          className: modalClass('body'),
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 199,
            columnNumber: 7
          }
        }, (cov_1rcczspfs8.b[35][0]++, icon) && (cov_1rcczspfs8.b[35][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: modalClass('icon'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 200,
            columnNumber: 18
          }
        }, icon)), this.renderTitle(),
        /*#__PURE__*/
        React.createElement("div", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 202,
            columnNumber: 9
          }
        }, children))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1rcczspfs8.f[17]++;

      var _ref14 = (cov_1rcczspfs8.s[87]++, this.props),
          footer = _ref14.footer,
          type = _ref14.type,
          onClose = _ref14.onClose,
          maskCloseAble = _ref14.maskCloseAble,
          position = _ref14.position,
          moveable = _ref14.moveable,
          zoom = _ref14.zoom,
          resizable = _ref14.resizable,
          hideClose = _ref14.hideClose,
          from = _ref14.from,
          top = _ref14.top,
          events = _ref14.events,
          fullScreen = _ref14.fullScreen;

      var className = (cov_1rcczspfs8.s[88]++, classnames(modalClass('panel', type, position, (cov_1rcczspfs8.b[36][0]++, zoom) && (cov_1rcczspfs8.b[36][1]++, !moveable) && (cov_1rcczspfs8.b[36][2]++, 'zoom')), this.props.className));
      var showClose = (cov_1rcczspfs8.s[89]++, typeof hideClose === 'boolean' ? (cov_1rcczspfs8.b[37][0]++, !hideClose) : (cov_1rcczspfs8.b[37][1]++, (cov_1rcczspfs8.b[38][0]++, maskCloseAble) || (cov_1rcczspfs8.b[38][1]++, maskCloseAble === null)));
      var maskStyle = (cov_1rcczspfs8.s[90]++, {
        paddingBottom: fullScreen ? (cov_1rcczspfs8.b[39][0]++, 0) : (cov_1rcczspfs8.b[39][1]++, top)
      });
      cov_1rcczspfs8.s[91]++;
      return (
        /*#__PURE__*/
        React.createElement(ZProvider, {
          value: true,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 227,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: {
            element: undefined
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 228,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, events, {
          style: maskStyle,
          className: modalClass('mask'),
          onMouseDown: this.handleMaskDown,
          onMouseUp: this.handleMaskUp,
          onClick: this.handleClose,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 229,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement(Card, {
          forwardedRef: this.savePanel,
          moveable: moveable,
          resizable: resizable,
          shadow: true,
          className: className,
          style: this.getStyle(),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 237,
            columnNumber: 13
          }
        }, (cov_1rcczspfs8.b[40][0]++, showClose) && (cov_1rcczspfs8.b[40][1]++,
        /*#__PURE__*/
        React.createElement("a", {
          className: modalClass('close'),
          onClick: onClose,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 246,
            columnNumber: 17
          }
        }, Icons.Close)), this.renderTitle(true), this.renderContent(), (cov_1rcczspfs8.b[41][0]++, footer) && (cov_1rcczspfs8.b[41][1]++,
        /*#__PURE__*/
        React.createElement(Card.Footer, {
          className: modalClass('footer', from),
          align: "right",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 253,
            columnNumber: 17
          }
        }, footer))))))
      );
    }
  }]);

  return Panel;
}(PureComponent);

Panel.defaultProps = DefaultValue;
Panel.displayName = void 0;
export { Panel as default };
cov_1rcczspfs8.s[92]++;
Panel.displayName = 'ShineoutModalPanel';